<template>
  <v-container fluid class="customer-page">
    <Create
      :createDialog="createDialog"
      @close="createDialog = false"
      @submit="onCustomerCreated"
    />

    <div class="customer-content">
      <router-view />
    </div>
  </v-container>
</template>
<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import customerStore from "./store.js";
import invoiceStore from "@/modules/Invoice/store.js";
import reportStore from "@/modules/Report/store.js";
import { mapGetters } from "vuex";

const Create = () => import("./components/Create");

export default {
  name: "customer-index",

  mixins: [RegisterStoreModule],

  components: {
    Create,
  },

  data() {
    return {
      createDialog: false,
    };
  },

  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },

  created() {
    this.registerStoreModule("customer", customerStore);
    this.registerStoreModule("invoice", invoiceStore);
    this.registerStoreModule("reportView", reportStore);
    document.title = "smplsale - Customer";
  },

  methods: {
    add() {
      this.createDialog = true;
    },

    onCustomerCreated() {
      this.createDialog = false;
      this.$events.emit("CustomerMiniList");
      this.$events.emit("customerProfileEvent");

      if (this.$route.path !== "/customer/list") {
        this.$router.push({ path: "/customer/list" });
      }
    },
  },
};
</script>

<style scoped>
.customer-page {
  background: #f8fafc;
  min-height: 100%;
}

.customer-header {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.customer-title {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.customer-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}

.customer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.customer-content {
  width: 100%;
}

@media (max-width: 600px) {
  .customer-page {
    padding: 10px !important;
  }

  .customer-actions {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .customer-actions .v-btn {
    width: 100%;
  }
}
</style>